import { render, staticRenderFns } from "./UserMaintain.vue?vue&type=template&id=4731d980"
import script from "./UserMaintain.vue?vue&type=script&lang=js"
export * from "./UserMaintain.vue?vue&type=script&lang=js"
import style0 from "./UserMaintain.vue?vue&type=style&index=0&id=4731d980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports